module.exports = __webpack_public_path__ + "static/product-ce48cf9d31d56bea4392af05d2a910a3.jpg";